import { Ratio } from 'react-bootstrap'

import { Pessoa } from '@core/models/entities'

import * as S from './styles'
import { ProfileDetailsItem } from './components'

export type ProfileDetailsProps = Partial<
  Pick<Pessoa, 'id' | 'nome' | 'email'> & {
    tipo: string
    identificacao: string
    identificacaoPrincipal: string
    tipoIdentificacaoPrincipal: string
    photo: File
  }
>

const ProfileDetails: React.FC<ProfileDetailsProps> = pessoa => {
  const identificacao =
    pessoa.identificacao ?? pessoa.identificacaoPrincipal ?? '-'
  const tipo = pessoa.tipo ?? pessoa.tipoIdentificacaoPrincipal ?? 'N/A'

  return (
    <>
      <S.PersonPicture>
        <Ratio aspectRatio={'1x1'} style={{ height: '100%' }}>
          <S.Picture
            src={
              pessoa.photo
                ? URL.createObjectURL(pessoa.photo)
                : 'https://imgur.com/vcZ08Ql.png'
            }
          ></S.Picture>
        </Ratio>
      </S.PersonPicture>

      <hr></hr>

      <>
        <ProfileDetailsItem label="Identificação" value={identificacao} />
        <ProfileDetailsItem label="Nome" value={pessoa.nome} />
        <ProfileDetailsItem label="Tipo" value={tipo} />
        <ProfileDetailsItem label="Email" value={pessoa.email} />
      </>
    </>
  )
}

export default ProfileDetails
